import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";

export default function PartnerBridge() {
    const { t } = useI18n();
    return (
        <section
            data-testid="partner-bridge"
            style={{
                background: "var(--itly-page)",
                padding: "88px 32px",
                borderTop: "1px solid var(--itly-border)",
            }}
        >
            <div
                className="itly-card"
                style={{
                    maxWidth: 900,
                    margin: "0 auto",
                    padding: "40px 44px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 32,
                    flexWrap: "wrap",
                }}
            >
                <div style={{ maxWidth: 480 }}>
                    <p
                        style={{
                            margin: 0,
                            fontFamily: "Inter, sans-serif",
                            fontSize: 12.5,
                            fontWeight: 700,
                            letterSpacing: "0.16em",
                            textTransform: "uppercase",
                            color: "var(--itly-orange-700)",
                        }}
                    >
                        {t("pb.eyebrow")}
                    </p>
                    <h3
                        className="itly-serif"
                        style={{
                            margin: "12px 0 8px",
                            fontSize: "clamp(26px, 2.6vw, 34px)",
                            lineHeight: 1.15,
                            color: "var(--itly-fg-strong)",
                            letterSpacing: "-0.015em",
                        }}
                    >
                        {t("pb.title_a")}
                        <em
                            style={{
                                fontStyle: "italic",
                                color: "var(--itly-orange-500)",
                                fontWeight: 500,
                            }}
                        >
                            {t("pb.title_b")}
                        </em>
                    </h3>
                    <p
                        style={{
                            margin: 0,
                            fontFamily: "Inter, sans-serif",
                            fontSize: 15,
                            color: "var(--itly-muted)",
                            lineHeight: 1.55,
                        }}
                    >
                        {t("pb.body")}
                    </p>
                </div>
                <Link
                    to="/partner"
                    data-testid="cta-partner-bridge"
                    className="itly-btn-primary"
                >
                    {t("pb.cta")}
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>
                </Link>
            </div>
        </section>
    );
}
